module.exports = __webpack_public_path__ + "static/media/wrong.b93fa4e3.mp3";